module.exports = __webpack_public_path__ + "img/clear@3x.cfc3aef.png";